var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { dummyConsole, noop } from './defs';
var patchedConsole = Object.assign({}, dummyConsole);
/** 启用全局console的开关函数 */
export function enableConsoleOutput(levels) {
    (levels || Object.keys(dummyConsole)).forEach(function (key) {
        var _a;
        patchedConsole[key] = ((_a = self.console) === null || _a === void 0 ? void 0 : _a[key]) || noop;
    });
}
/**
 * 在console中输出日志
 */
export function consoleOutput(level, logPrefix) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    patchedConsole[level].apply(patchedConsole, __spreadArray([logPrefix], args, false));
}
